import React from 'react';
import { object, arrayOf, func, string, oneOfType } from 'prop-types';

export default function SortBy({ items, currentSort, updateSort }) {
    if (!items || !items.length) return null;

    return (
        <div className="sort-by">
            <div className="select-wrapper">
                <div className="label-wrapper">
                    <label htmlFor="listing-sort">Sort by</label>
                </div>
                <div className="input-wrapper">
                    <select
                        id="listing-sort"
                        value={currentSort ? JSON.stringify(currentSort) : ''}
                        onChange={e => updateSort(e.target.value ? JSON.parse(e.target.value) : null)}
                    >
                        {items.map(sort => (
                            <option key={sort.label} value={JSON.stringify(sort)}>{sort.label}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}

SortBy.propTypes = {
    items: arrayOf(object).isRequired,
    currentSort: oneOfType([string, object]),
    updateSort: func.isRequired
};

SortBy.defaultProps = { currentSort: '' };
